import React from 'react';

const CrossRoundelIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='none' fillRule='evenodd'>
      <circle fill='#DB0000' cx='16' cy='16' r='12' />
      <g stroke='#FFF' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
        <path d='m11 11 10 10M21 11 11 21' />
      </g>
    </g>
  </svg>
);

export default CrossRoundelIcon;
